import React from "react";
import {
  STATUS_OPTIONS,
  RESOURCE_TYPE_OPTIONS,
  USER_MANAGEMENT_ACTIONS,
} from "../../utils/constants";
import { translate } from "../../utils/translations/translate";
import { Link } from "react-router-dom";
import Button from "../UI/Button";
import { SITE_LINKS_SCHEMA } from "../../router/navlinks";
import { Popupmenu } from "../UI/PopupMenu";
import Input from "../UI/Input";
import { Dropdown } from "../UI/Dropdown";
import { StyledStatusFilter } from "../Projects/styles";
const HEADER_STATUS_OPTIONS = [{
  label:"All Status",
  value:''
},...STATUS_OPTIONS]

const HEADER_RESOURCE_OPTIONS = [
  {
    label:"All Account Types",
    value:''
  },
  ...RESOURCE_TYPE_OPTIONS
]
const UserListFilters = ({
  resourceKey,
  setResourceKey,
  resourceType,
  statusKey,
  setStatusKey,
  setResourceType,
  onPopupOptionSelect,
  selectedRows
}) => {
  return (
    <header className="tma__project-table-filters">
      <div className="tma__project-table-filters--left">
        <Input
          id={"tma_header_search"}
          labelText=""
          placeholderLabelText={translate("labels.searchResources")}
          value={resourceKey}
          onChange={(e) => {
            setResourceKey(e.target.value);
          }}
        />
        <StyledStatusFilter>
          <Dropdown
            placeholder={translate("labels.status")}
            id={"tma_status_drpdwn"}
            options={HEADER_STATUS_OPTIONS}
            initialValue={statusKey}
            onChange={({value})=>{
              setStatusKey(value);
            }}
          />
        </StyledStatusFilter>
        <StyledStatusFilter>
          <Dropdown
            placeholder={translate("labels.resourceType")}
            id={"tma_rsrc_drpdwn"}
            options={HEADER_RESOURCE_OPTIONS}
            initialValue={resourceType}
            onChange={({value})=>{
              setResourceType(value);
            }}
          />
        </StyledStatusFilter>
      </div>
      <div className="tma__project-table-filters--right">
        <Popupmenu
          variantStyle="secondary"
          label={translate("labels.moreActions")}
          popupOptions={USER_MANAGEMENT_ACTIONS}
          onOptionSelect={({key})=>{
            onPopupOptionSelect(key);
          }}
          disabled={selectedRows.length===0}
        />
        <Link
          className="tma__add_project_link"
          to={SITE_LINKS_SCHEMA.CREATE_RESOURCE}
        >
          <Button
            className="tma__add_project"
            text={translate("labels.newResourceAdd")}
          />
        </Link>
      </div>
    </header>
  );
};

export default UserListFilters;
